import taxiImg from "../assets/taxi.png";

// Caché para las imágenes rotadas (key: heading -> value: base64 DataURL)
const rotatedCache = {};

/**
 * Calcula el rumbo (bearing) en grados entre dos coordenadas geográficas
 * @param {Object} startCoords { lat, lon }
 * @param {Object} endCoords { lat, lon }
 * @returns {number} Rumbo en grados (0 a 360)
 */
export const calculateBearing = (startCoords, endCoords) => {
  if (!startCoords || !endCoords) return 0;
  
  const lat1 = (startCoords.lat * Math.PI) / 180;
  const lon1 = (startCoords.lon * Math.PI) / 180;
  const lat2 = (endCoords.lat * Math.PI) / 180;
  const lon2 = (endCoords.lon * Math.PI) / 180;
  
  const dLon = lon2 - lon1;
  
  const y = Math.sin(dLon) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
  
  let radians = Math.atan2(y, x);
  let bearing = (radians * 180) / Math.PI;
  
  return (bearing + 360) % 360;
};

/**
 * Carga y rota el ícono de taxi usando un canvas en memoria, agregando un indicador de viaje si está activo
 * @param {number} heading Rumbo en grados
 * @param {boolean} inTrip Indica si el conductor está en viaje activo
 * @returns {Promise<string>} Promesa que resuelve a un DataURL base64 de la imagen rotada
 */
export const getRotatedTaxiIcon = (heading, inTrip = false) => {
  // Normalizar el rumbo a enteros para mejor rendimiento del caché
  const roundedHeading = Math.round(heading || 0) % 360;
  const cacheKey = `${roundedHeading}-${inTrip}`;
  
  if (rotatedCache[cacheKey]) {
    return Promise.resolve(rotatedCache[cacheKey]);
  }
  
  return new Promise((resolve) => {
    const img = new Image();
    img.src = taxiImg;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      
      const maxDim = Math.max(img.width, img.height) || 40;
      canvas.width = maxDim;
      canvas.height = maxDim;
      
      // Mover el origen al centro del canvas
      ctx.translate(maxDim / 2, maxDim / 2);
      // Aplicar rotación (Norte=0, sentido horario)
      ctx.rotate((roundedHeading * Math.PI) / 180);
      
      // Dibujar la imagen centrada
      ctx.drawImage(img, -img.width / 2, -img.height / 2, img.width, img.height);
      
      // Restaurar transformación a la identidad para dibujar el círculo verde en posición fija (esquina superior derecha)
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      
      if (inTrip) {
        // Círculo indicador de viaje activo (verde esmeralda brillante con borde blanco)
        ctx.beginPath();
        ctx.arc(maxDim - 6, 6, 5, 0, 2 * Math.PI);
        ctx.fillStyle = "#10B981"; // Emerald green
        ctx.fill();
        ctx.strokeStyle = "#FFFFFF";
        ctx.lineWidth = 1.5;
        ctx.stroke();
      }
      
      const dataUrl = canvas.toDataURL("image/png");
      rotatedCache[cacheKey] = dataUrl;
      resolve(dataUrl);
    };
    img.onerror = () => {
      resolve(taxiImg);
    };
  });
};
